export default {
  name: [
    v => !!v || 'Nazwa jest wymagana',
    v => v && v.length >= 2 || 'Nazwa musi mieć co najmniej 2 znaki',
    v => v && v.length <= 255 || 'Nazwa może mieć maksymalnie 255 znaków',
  ],
  description: [
    v => !!v || 'Opis jest wymagany',
    v => v && v.length >= 2 || 'Opis musi mieć co najmniej 2 znaki',
    v => v && v.length <= 255 || 'Opis może mieć maksymalnie 255 znaków',
  ],
  date: [
    v => !!v || 'Data jest wymagana',
  ],
}